"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _constants = require("@seedlang/constants");
var _excluded = ["key"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var FilterTagsWrapper = function FilterTagsWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      _classCallCheck(this, _class2);
      return _callSuper(this, _class2, arguments);
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "filterSettings",
      get: function get() {
        if (this.props.showSeenAny) {
          return this.props.filterSettings.filter(function (item) {
            return (0, _utils.isPresent)(item.tagDisplay) && ((0, _utils.isPresent)(item.value) || item.key === 'seen');
          });
        }
        return this.props.filterSettings.filter(function (item) {
          return (0, _utils.isPresent)(item.tagDisplay) && (0, _utils.isPresent)(item.value);
        });
      }
    }, {
      key: "onClick",
      value: function onClick(item) {
        if ((0, _lodash.isFunction)(item.onChange)) {
          item.onChange(null);
        } else if (item.key === 'seen' && item.value !== false && !item.value) {
          this.props.onSetFilter(item.userKey, false);
        } else {
          this.props.onSetFilter(item.userKey, null);
        }
      }
    }, {
      key: "backgroundColor",
      get: function get() {
        if (this.props.inDeckOptions) {
          if (this.props.disabled) {
            return '#CCC';
          }
          return _constants.Theme.blue;
        }
        return '#FFF';
      }
    }, {
      key: "color",
      get: function get() {
        if (this.props.inDeckOptions) {
          if (this.props.disabled) {
            return _constants.Theme.lightGray;
          }
          return '#FFF';
        }
        return '#333';
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          key = _this$props.key,
          otherProps = _objectWithoutProperties(_this$props, _excluded);
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, otherProps, {
          filteredFilterSettings: this.filterSettings,
          onClick: this.onClick,
          color: this.color,
          backgroundColor: this.backgroundColor
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filterSettings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "backgroundColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "backgroundColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "color", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "color"), _class2.prototype), _class2)) || _class;
};
FilterTagsWrapper.displayName = 'FilterTagsWrapper';
var _default = exports["default"] = FilterTagsWrapper;